import { toast } from 'react-hot-toast';
import { AxiosError } from 'axios';
import { resetGroupExamsSchedule } from 'entities/groups';
import { getGroupExamsSchedule } from 'entities/groups/api';
import { useInvisibleCaptcha } from 'features/index';
import {
  isNonEmptyStr,
  isPositiveIntStr,
  useAppDispatch,
  useAppSelector,
} from 'shared/lib';

export const useExamsSchedule = () => {
  const { requestText } = useAppSelector(
    (state) => state.schedulePublicReducer,
  );

  const {
    dataForGroupExamsSchedule,
    groupExamsScheduleError,
    groupExamsScheduleIsLoading,
  } = useAppSelector((state) => state.groupsReducer);

  const { token, captchaStatus } = useInvisibleCaptcha();

  const dispatch = useAppDispatch();

  const examsScheduleQuery = async () => {
    try {
      if (token) {
        if (requestText && isNonEmptyStr(requestText as string)) {
          const trimmed = requestText.trim();
          if (isPositiveIntStr(trimmed)) {
            await dispatch(
              getGroupExamsSchedule({
                group: requestText as string,
              }),
            ).unwrap();
          } else {
            dispatch(resetGroupExamsSchedule());
          }
        }
      }
    } catch (error) {
      let errorMessage = 'Ошибка при выполнении поиска';
      if (error instanceof AxiosError) {
        if (error.response?.status === 401) {
          console.error(error);
          errorMessage = '';
        } else {
          errorMessage = error.message;
        }
      } else if (typeof error === 'string') {
        errorMessage = error;
      }
      if (errorMessage) toast.error(errorMessage);
    }
  };

  const isSkeleton =
    groupExamsScheduleIsLoading || !token || captchaStatus !== 'success';

  return {
    examsScheduleQuery,
    isSkeleton,
    token,
    requestText,
    dataForGroupExamsSchedule,
    groupExamsScheduleError,
    groupExamsScheduleIsLoading,
  };
};
